// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/resources/styles/main.css
// module id = 1618
// module chunks = 0